import React from "react";
import { Image, Text, View } from "@react-pdf/renderer";
import { FillTheBlankQuestionType } from "../types";
import styles from "./styles";
import { t } from "i18next";
import renderMarkdownText from "./markdownParseFunction";

type Props = {
  question: FillTheBlankQuestionType;
  showAnswer: boolean;
  questionIndex: number;
};

export default function FillTheBlankQuestion({
  question,
  showAnswer,
  questionIndex,
}: Props) {
  const { body, answer, point, image, mediaUrl, learningOutcome } = question;
  let imageFile: string | Buffer | undefined;
  if (image && image.startsWith("data:image")) {
    const base64 = image.split(",")[1];
    const buff = Buffer.from(base64, "base64");
    imageFile = buff;
  } else if (image) {
    imageFile = image;
  } else if (mediaUrl) {
    imageFile = mediaUrl;
  }

  const bodyParts = body.split(/{{BLANK}}/);
  return (
    <View
      style={[styles.questionContainerH, { marginVertical: 4 }]}
      wrap={false}
    >
      <View style={styles.questionContainerV}>
        <Text style={styles.questionNumber}>{`${questionIndex + 1}. `}</Text>
        <View style={styles.questionContainerH}>
          {imageFile && <Image src={imageFile} style={styles.questionImage} />}
          <View style={styles.questionContainerV}>
            <Text style={styles.questionBody}>
              {bodyParts.map((part, index) => {
                const key = `${question.type}-${questionIndex}-${index}`;
                if (index === bodyParts.length - 1) {
                  return (
                    <React.Fragment key={key}>
                      {renderMarkdownText(part)}
                    </React.Fragment>
                  );
                }
                return (
                  <React.Fragment key={key}>
                    {renderMarkdownText(part)}
                    {showAnswer ? (
                      <Text style={styles.answer}>{answer?.[index] || ""}</Text>
                    ) : (
                      <Text>{"_".repeat(answer?.[index]?.length || 5)}</Text>
                    )}
                  </React.Fragment>
                );
              })}
              <Text style={styles.questionNumber}>
                ({point} {t("pdf_renderer.point")})
              </Text>
            </Text>
          </View>
        </View>
      </View>
      {showAnswer && learningOutcome && (
        <Text style={[styles.answer, styles.questionBody]}>
          {t("pdf_renderer.outcome")}: {renderMarkdownText(learningOutcome)}
        </Text>
      )}
    </View>
  );
}
